import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from './store'
import Routes from './routes'
import "babel-polyfill"
// import './styles/index.less'

ReactDOM.render(
  <Provider>
    <Routes />
  </Provider>,
  document.getElementById('root'),
)
